/**
 * The backend client calls getAccessTokenSilently before every request,
 * to ensure an up-to-date access token.
 * getAccessTokenSilently only makes a network call if the token is expired.
 * Otherwise, it returns the cached token.
 */

import { useAuth0 } from '@auth0/auth0-react'
import { useMemo } from 'react'
import BackendClient from './BackendClient'

const useBackendClient = (): BackendClient => {
  const { getAccessTokenSilently, logout } = useAuth0()

  return useMemo(() => {
    return new BackendClient(getAccessTokenSilently, logout)
  }, [getAccessTokenSilently, logout])
}

export default useBackendClient
